import React from 'react'
import PostTitle from './post-title'

interface PostHeaderProps {
  excerpt?: string
  title: string
}

const PostHeader: React.FC<PostHeaderProps> = ({ excerpt, title }) => (
  <>
    <PostTitle>{title}</PostTitle>
    <div className='prose'>
      {excerpt && (
        <div
          dangerouslySetInnerHTML={{ __html: excerpt }}
          className='text-lg font-thin text-gray-500 text-opacity-90'
        />
      )}
    </div>
  </>
)

export default PostHeader
